import { useState } from "react";
import ReactMarkdown from "react-markdown";
import { Sparkles } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { streamAI, openAI } from "./stream";

export const AiExplain = ({ slug }) => {
  const { profile } = useAuth();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true); setText("");
    try {
      await streamAI(`/ai/explain/${slug}`, {}, (ev) => { if (ev.delta) setText((t) => t + ev.delta); if (ev.error) setText(ev.error); });
    } catch (e) { setText(e.message); } finally { setBusy(false); }
  };
  if (!profile) return null;
  return (
    <section className="space-y-2" data-testid="ai-explain">
      <div className="flex gap-2">
        <button onClick={run} disabled={busy} className="btn-ghost flex-1 !text-[var(--violet)]" data-testid="ai-explain-btn"><Sparkles className="w-4 h-4" />{busy ? "Explaining…" : "Explain with AI"}</button>
        <button onClick={() => openAI({ context: { slug } })} className="btn-ghost" data-testid="ai-ask-market-btn">Ask a question</button>
      </div>
      {text && <div className="ai-md text-sm text-slate-300 leading-relaxed rounded-2xl border border-[var(--violet)]/30 bg-[var(--violet)]/5 p-4" data-testid="ai-explain-text"><ReactMarkdown>{text}</ReactMarkdown></div>}
    </section>
  );
};
